// @flow
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import SearchIcon from "@material-ui/icons/Search";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type { IconStylesClassesType } from "../../../global/styles/iconStyles";
import { iconStyles } from "../../../global/styles/iconStyles";
import { SingleTextField } from "imagus-components";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...iconStyles(theme),
  loadingIcon: {
    width: "24px",
    height: "24px"
  }
});

type SearchBarStatesType = {
  inputVal: string,
  loading: boolean
};

type SearchBarClassesType = {
  ...IconStylesClassesType,
  loadingIcon: DictionaryType
};

type SearchBarPropsType = {
  classes: SearchBarClassesType,
  updating: string,
  fetchPeople: Function,
  clearSelect: Function
};

class SearchBar extends Component<SearchBarPropsType, SearchBarStatesType> {
  timeout: TimeoutID;
  constructor(props: SearchBarPropsType) {
    super(props);
    this.state = {
      inputVal: "",
      loading: false
    };
  }

  componentDidUpdate(prevProps: SearchBarPropsType) {
    if (prevProps.updating !== this.props.updating) {
      this.setState({ loading: this.props.updating !== undefined });
    }
  }

  handleChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });

    clearTimeout(this.timeout);
    this.timeout = setTimeout(
      function(val: string) {
        this.props.clearSelect();
        this.props.fetchPeople(val, true);
      }.bind(this, value),
      500
    );
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    const loading = this.state.loading;

    return (
      <SingleTextField
        isRequired={false}
        label="Search..."
        name="inputVal"
        value={this.state.inputVal}
        onChange={this.handleChange}
        inpuType="text"
        endAdornment={
          <InputAdornment position="end">
            {this.state.loading ? (
              <CircularProgress
                size={18}
                color="primary"
                className={classes.loadingIcon}
              />
            ) : (
              <SearchIcon className={classes.greenIcon} />
            )}
          </InputAdornment>
        }
      />
    );
  }
}

export default withStyles(styles)(SearchBar);
